module.exports = __webpack_public_path__ + "static/img/bg-es.fbea9cbc.png";